import { parseWebEnv } from '@tsgecart/validation';

export const webEnv = parseWebEnv(import.meta.env);
